// src/eAxios.js

import axios from 'axios';
import config from './config'; // Adjust the path if necessary

const eAxios = axios.create({
  baseURL: config.api.baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default eAxios;
